import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
const json = {
  1: {
    unit: "Unit 1",
    id: "SB7-U1-P16-E1",
    audio: "",
    video: "",
    component: T6,
    // protractor: true,
    hideBtnFooter: true,
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <div>
          <ul>
            <li>Độ là đơn vị đo góc, kí hiệu là °. Chẳng hạn một độ viết là 1°.</li>
            <li>Góc đỉnh O; cạnh OA, OB bằng sáu mươi độ. Sáu mươi độ viết là 60°.</li>
          </ul>
          <video src="Audios/guide/p23_e1.mp3" controls style="width: 100%; height: 2cm"></video>      
        </div>
        
        `,
      },
    ],
    // guideModal: [
    //   {
    //     title: "hướng dẫn",
    //     description: `
    //     <div>
    //     <ul>
    //       <li>Độ là đơn vị đo góc, kí hiệu là °. Chẳng hạn một độ viết là 1°.</li>
    //       <li>Góc đỉnh O; cạnh OA, OB bằng sáu mươi độ. Sáu mươi độ viết là 60°.</li>
    //     </ul>
    //   </div>
        
    //     `,
    //   },
    // ],
    animated: true,
    titleQuestion: [
      {
        title: ` 
          
            `,
        color: "rgb(253,200,156)",
      },
    ],
    questions: [
      {
        title: `
        <div style="position: relative;">
            <img  src ='/img/FriendsPlus/Page23/Demo/bang.jpg' style='height:12cm;'/>    

            <img id="image1" src ='/img/FriendsPlus/Page23/Demo/a.png' style="position: absolute; bottom:0;left:0px;width: 140px; opacity:0;"/>     

            <div style="position: absolute; bottom: 222px; left: 160px; font-size: 16px;padding: 5px;">
              <span id="span-text"  style="margin-right: 5px; display: none;">Tớ</span>
              <span  id="span-text" style="margin-right: 5px; display: none;">thấy</span>
              <span  id="span-text" style="margin-right: 5px; display: none;">góc</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">đỉnh</span><br/>
              <span id="span-text"  style="margin-right: 5px; display: none;">O</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">cạnh</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">OA,</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">OB</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">bé</span><br/>
              <span id="span-text"  style="margin-right: 5px; display: none;">hơn</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">góc</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">đỉnh</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">P</span><br/>
              <span id="span-text"  style="margin-right: 5px; display: none;">cạnh</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">PM,</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">PN</span>
            </div>    

            <img id="image2" src ='/img/FriendsPlus/Page23/Demo/b.png' style="position: absolute; bottom:0;right:0px;width: 100px; opacity:0;"/>  

            <div style="position: absolute; bottom: 149px; right: 262px; font-size: 16px;padding: 5px;">
              <span id="span-text2"  style="margin-right: 5px; display: none;">Tớ</span>
              <span id="span-text2"  style="margin-right: 5px; display: none;">thấy</span>
              <span id="span-text2"  style="margin-right: 5px; display: none;">hai</span>
              <span id="span-text2"  style="margin-right: 5px; display: none;">góc</span><br/>
              <span id="span-text2"  style="margin-right: 5px; display: none;">này</span>
              <span id="span-text2"  style="margin-right: 5px; display: none;">bằng</span>
              <span id="span-text2"  style="margin-right: 5px; display: none;">nhau</span>
            </div>    

            <img id="image3" src ='/img/FriendsPlus/Page23/Demo/c.png' style="position: absolute; bottom:24px;right:0px;width: 100px; opacity:0;"/> 

            <div style="position: absolute; bottom: 199px; right: 25px; font-size: 16px;padding: 5px;">
            <span id="span-text3"  style="margin-right: 5px; display: none;">Phải</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">dùng</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">thước</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">đo</span><br/>
            <span id="span-text3"  style="margin-right: 5px; display: none;">góc</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">để</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">đo</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">mỗi</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">góc</span><br/>
            <span id="span-text3"  style="margin-right: 5px; display: none;">bằng</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">bao</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">nhiêu</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">độ</span><br/>
            <span id="span-text3"  style="margin-right: 5px; display: none;">rồi</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">so</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">sánh</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">thì</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">mới</span><br/>
            <span id="span-text3"  style="margin-right: 5px; display: none;">biết</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">được</span>
            </div>    
            
        </div>
                 
              `,
        answer: [],
      },
    ],
  },
  2: {
    unit: "Unit 1",
    id: "SB7-U1-P16-E3",
    audio: "",
    video: "",
    component: T6,
    // maxHeight: "18cm",
    // overflowY: "auto",
    protractor: [
      {
        decreaseLeft: 190,
        decreaseTop: 225,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -20,
        rotateTopLess0: 50,

        inputLeft: "728px",
        inputTop: "254px",
        ResultProtractor:[
          {
            textResult: 60,
            styleResult:{
              top: -228,
              left:-625
            }
          },
          {
            textResult: 60,
            styleResult:{
              top:-38,
              left:-522
            },
          },
          {
            textResult: 120,
            styleResult:{
              top:-225,
              left:-80
            },
          },
          {
            textResult: 120,
            styleResult:{
              top:-30,
              left:-420
            },
          },
        ],
        result: [
          {
            id: 0,
            top: 36,
            left: -193,
            rotate: 0,
          },
          {
            id: 1,
            top: 36,
            left: -192,
            rotate: 121,
          },
          {
            id: 2,
            top: 36,
            left: 358,
            rotate: 0,
          },
          {
            id: 3,
            top: 38,
            left: 358,
            rotate: -61,
          },
        ],
      },
    ],
    hideBtnFooter: true,
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
    //     <span>Tra cứu</span>
        
    //     `,
    //   },
    // ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span><b>Đo góc đỉnh O; cạnh OA, OB.</b><br>
        - Em hãy di chuyển thước đo góc đến vị trí sao cho tâm của thước trùng với đỉnh O của góc; cạnh OB nằm trên đường kính của nửa hình tròn của thước.<br>
        - Sau đó hãy nhập toạ độ để xoay thước (nếu cần) sao cho cạnh OA đi qua một vạch trên nửa đường tròn của thước, chẳng hạn vạch ghi số 60, ta được số đo góc đỉnh O; cạnh OA, OB bằng 60°.
        <video src="Audios/guide/p23_e2.mp3" controls style="width: 100%; height: 2cm"></video>      
        </span>
        
        `,
      },
    ],
    titleQuestion: [
      {
        title: ` 
        <img src ='/img/FriendsPlus/Page23/Demo2/1.jpg' style='width:200px'/>
            `,
        color: "rgb(253,200,156)",
      },
    ],
    questions: [
      {
        title: `
        <div style="display: flex;margin-top:50px; margin-left:-40px">
          <img
            id="drag"
            src="/img/FriendsPlus/Page23/Demo2/3.png"
            alt=""
            width="250px"
          />
          <img
          id="drag"
          src="/img/FriendsPlus/Page23/Demo2/5.png"
          alt=""
          width="300px"
          style='margin-left:150px'
          />
        </div>
        <div style="position:absolute;top:238px;left:0px; width: 15px;height: 15px;background-color: red;border-radius: 50%;">
        </div>
        <div style="position:absolute;top:238px;left:550px; width: 15px;height: 15px;background-color: red;border-radius: 50%;">
        </div>
        <div
          id="protractor"
          style="position: absolute;top: 37px;left: 663px;width: 400px; height: 420px;z-index: 1"
        >
          <img
            src="/img/test/protractor-removebg-preview2.png"
            style="width: 400px"
            alt="image"
          />
        </div>
`,
        answer: [],
      },
    ],
  },
  3: {
    unit: "Unit 1",
    id: "SB7-U1-P16-E3",
    audio: "Audios/Chúng ta cùng học về góc.mp3",
    video: "",
    component: T6,
    // hiddenNewWords:true,
    autoPlay: true,
    hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='position:relative;width:20cm'>
          <div style='position:absolute;top:-190px;left:35px;'>
              <img src ='/img/FriendsPlus/Page23/Demo3/1.png' style='height:6cm'/>
              <div style='position:absolute;top:60px;left:250px;color:rgb(246 106 126);width:15cm;font-weight:bold;font-size:35px'>
              
                GÓC VÀ ĐƠN VỊ ĐO GÓC
              </div>
              <div style='position:absolute;background:rgb(125 208 179);top:201px;left:-180px;text-align:center;border:15px solid;border-radius:30px;padding:10px 50px; color:white;font-weight:900;font-size:35px'>
              
                Bài 7
              </div>
          </div>
        </div>
          <div style='margin-top:170px;margin-left:70px;background:rgb(254 252 208);text-align:center;border:15px solid;width:15cm;border-radius:30px;padding:20px 50px; color:rgb(246 106 126);font-weight:bold;font-size:35px'>
              ĐO GÓC, ĐƠN VỊ ĐO GÓC
          </div>
              `,
        answer: [],
      },
    ],
  },
};

export default json;
